import Urls from '../constants/Urls';
class FaviconService {
  static getFaviconUrl({
    domain
  }) {
    return `${Urls.MANGOOLS_PROXY_URL}/?icon=${encodeURIComponent(domain)}`;
  }
}
export default FaviconService;